import type { UserSettingsIdentifier } from '@/types/userSettingsApiTypes';
import { buildApiPathWithQuery } from '@/utils/buildApiPathWithQuery';

type GetUserSettingsUrlParams = {
  identifier?: UserSettingsIdentifier;
};

export function getUserSettingsUrl({ identifier }: GetUserSettingsUrlParams = {}) {
  if (identifier) {
    return buildApiPathWithQuery('/api/user/settings', { identifier });
  }

  return '/api/user/settings';
}
